var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShorterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 5,
    viewBox: "0 0 14 5",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.601562 0.6C0.601562 0.268629 0.870192 0 1.20156 0H12.8016C13.1329 0 13.4016 0.268629 13.4016 0.6C13.4016 0.931371 13.1329 1.2 12.8016 1.2H1.20156C0.870192 1.2 0.601562 0.931371 0.601562 0.6ZM0.601562 4C0.601562 3.66863 0.870192 3.4 1.20156 3.4H7.20156C7.53293 3.4 7.80156 3.66863 7.80156 4C7.80156 4.33137 7.53293 4.6 7.20156 4.6H1.20156C0.870192 4.6 0.601562 4.33137 0.601562 4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShorterIcon);
export default __webpack_public_path__ + "static/media/ShorterIcon.bf342c85e2363878a242c6df3529180f.svg";
export { ForwardRef as ReactComponent };